module.exports = __webpack_public_path__ + "static/img/Explorer@2x.e2253334.png";